import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { LineChartComponent } from 'src/app/shared/component/charts/line-chart/line-chart.component';
import { LineChart } from 'src/app/shared/model';

@Component({
  selector: 'app-statistics-chart',
  standalone: true,
  imports: [CommonModule, LineChartComponent],
  templateUrl: './statistics-chart.component.html',
  styleUrls: ['./statistics-chart.component.scss'],
})
export class StatisticsChartComponent implements OnInit {
  @Input() labels: string[] = [];
  @Input() data: LineChart[] = [];
  constructor() {}

  ngOnInit(): void {}
}
